export default __webpack_public_path__ + "static/media/ico-ms-office.05bd79a6.svg";